import { ThemeProvider as FluentThemeProvider } from '@fluentui/react/lib/Theme';
import type { FC } from 'react';
import React from 'react';

import type { ThemeProviderProps } from './ThemeProvider.types';

const ThemeProvider: FC<ThemeProviderProps> = (props) => <FluentThemeProvider {...props} applyTo="none" />;

export default ThemeProvider;
